export default "__VITE_ASSET__DDz$AXlt__"